import { Button, Collapse, Table, Row, Col } from 'antd';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import hocFrom from '../../../components/forms/HocFrom';
import DashboardContext from '../../../Context';
import InputDate from '../../../components/inputs/InputDate';
import InputControl from '../../../components/inputs/InputControl';
import InputNumber from '../../../components/inputs/InputNumber';
import InputControlAsync from '../../../components/inputs/InputControlAsync';
import InputControlAsyncMulti from '../../../components/inputs/InputControlAsyncMulti';
import toaster from '../../../helper/toaster';

const InsuranceReport = () => {
  const { urldashboard, authentication } = useContext(DashboardContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [excelLoading, setExcelLoading] = useState(false);
  const [payvastPersonalCode, setPayvastPersonalCode] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [hasInsuranceType, setHasInsuranceType] = useState(null);
  const [workerId, setWorkerId] = useState(null);
  const [profileBusinessType, setProfileBusinessType] = useState(null);
  const [customerIds, setCustomerIds] = useState([]);
  const [withoutCustomerIds, setWithoutCustomerIds] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 50,
  });

  const { Panel } = Collapse;

  useEffect(() => {
    dataFetching({
      page: pagination.page,
      pageSize: pagination.pageSize,
      payvastPersonalCode: payvastPersonalCode,
      hasInsuranceType: hasInsuranceType,
      fromDate: fromDate,
      toDate: toDate,
      workerId: workerId,
      profileBusinessType: profileBusinessType,
      customerIds: customerIds,
      withoutCustomerIds: withoutCustomerIds,
    });
  }, []);

  const dataFetching = async ({
    page,
    pageSize,
    payvastPersonalCode,
    hasInsuranceType,
    fromDate,
    toDate,
    workerId,
    profileBusinessType,
    customerIds,
    withoutCustomerIds,
  }) => {
    setLoading(true);

    try {
      let url = '/workerInsuranceReport/get';

      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({
          page,
          pageSize,
          payvastPersonalCode,
          hasInsuranceType,
          fromDate,
          toDate,
          workerId,
          profileBusinessType,
          customerIds,
          withoutCustomerIds,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      setData(data?.data);
      setTotalRecord(data.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handleTableChange = (newPagination) => {
    dataFetching({
      page: newPagination.current,
      pageSize: newPagination.pageSize,
      payvastPersonalCode: payvastPersonalCode,
      hasInsuranceType: hasInsuranceType,
      fromDate: fromDate,
      toDate: toDate,
      workerId: workerId,
      profileBusinessType: profileBusinessType,
      customerIds: customerIds,
      withoutCustomerIds: withoutCustomerIds,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      render: (item, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'نام نیرو',
      dataIndex: 'workerFullName',
      key: 'workerFullName',
    },
    {
      title: 'کد پرسنلی',
      dataIndex: 'personalCode',
      key: 'personalCode',
      render: (value) => <span> {value ? value : '-'}</span>,
    },
    {
      title: 'کد پرسنلی پیوست',
      dataIndex: 'payvastPersonalCode',
      key: 'payvastPersonalCode',
      render: (payvastPersonalCode) => (
        <span> {payvastPersonalCode ? payvastPersonalCode : '-'}</span>
      ),
    },
    {
      title: 'تعداد کارهای انجام‌شده',
      dataIndex: 'numberOfDonedWorks',
      key: 'numberOfDonedWorks',
      render: (numberOfDonedWorks) => (
        <span> {numberOfDonedWorks ? numberOfDonedWorks : '-'}</span>
      ),
    },
    {
      title: 'مانده حساب کل',
      dataIndex: 'totalBalance',
      key: 'totalBalance',
      render: (totalBalance) =>
        totalBalance >= 0 ? (
          <span style={{ color: 'darkGreen' }}>
            {`${totalBalance.toLocaleString()} ریال`}
          </span>
        ) : (
          <span style={{ color: 'crimson' }}>
            {`${Number(
              String(totalBalance).replace(String(totalBalance)[0], '')
            ).toLocaleString()} ریال`}
          </span>
        ),
    },
    {
      title: 'شماره شبا',
      dataIndex: 'shebaCode',
      key: 'shebaCode',
      render: (shebaCode) => <span> {shebaCode ? shebaCode : '-'}</span>,
    },
  ];

  const search = () => {
    if (!fromDate) {
      return toaster.error('لطفا تاریخ شروع را وارد کنید');
    }

    if (!toDate) {
      return toaster.error('لطفا تاریخ پایان را وارد کنید');
    }

    dataFetching({
      page: 1,
      pageSize: 20,
      payvastPersonalCode: payvastPersonalCode,
      hasInsuranceType: hasInsuranceType,
      fromDate: fromDate,
      toDate: toDate,
      workerId: workerId,
      profileBusinessType: profileBusinessType,
      customerIds: customerIds,
      withoutCustomerIds: withoutCustomerIds,
    });
  };

  const reset = () => {
    setFromDate(null);
    setToDate(null);
    setPayvastPersonalCode('');
    setHasInsuranceType(null);
    setWorkerId(null);
    setProfileBusinessType(null);
    setCustomerIds([]);
    setWithoutCustomerIds([]);

    dataFetching({
      page: 1,
      pageSize: 20,
      payvastPersonalCode: '',
      hasInsuranceType: null,
      fromDate: null,
      toDate: null,
      workerId: null,
      profileBusinessType: null,
      customerIds: [],
      withoutCustomerIds: [],
    });
  };

  const getExcel = () => {
    if (!fromDate) {
      return toaster.error('لطفا تاریخ شروع را وارد کنید');
    }

    if (!toDate) {
      return toaster.error('لطفا تاریخ پایان را وارد کنید');
    }
    getExcelReport({
      page: pagination.page,
      pageSize: pagination.pageSize,
      payvastPersonalCode: payvastPersonalCode,
      hasInsuranceType: hasInsuranceType,
      fromDate: fromDate,
      toDate: toDate,
      workerId: workerId,
      profileBusinessType: profileBusinessType,
      customerIds: customerIds,
      withoutCustomerIds: withoutCustomerIds,
    });
  };

  const getExcelReport = async ({
    page,
    pageSize,
    payvastPersonalCode,
    hasInsuranceType,
    fromDate,
    toDate,
    workerId,
    profileBusinessType,
    customerIds,
    withoutCustomerIds,
  }) => {
    setExcelLoading(true);

    try {
      let url = '/workerInsuranceReport/getExcel';

      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({
          page,
          pageSize,
          payvastPersonalCode,
          hasInsuranceType,
          fromDate,
          toDate,
          workerId,
          profileBusinessType,
          customerIds,
          withoutCustomerIds,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
          responseType: 'arraybuffer',
        }
      );

      let blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'insurance_report.xlsx';
      link.click();
      setExcelLoading(false);
    } catch (error) {
      setExcelLoading(false);
    }
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ flex: 1 }}>
          <Collapse defaultActiveKey={['0']}>
            <Panel header='جستجو' key='1'>
              <Row gutter={20}>
                <Col span={6}>
                  <InputDate
                    label='از تاریخ'
                    name='fromDate'
                    defaultValue={fromDate}
                    handelValue={(_, value) => setFromDate(value)}
                  />
                </Col>
                <Col span={6}>
                  <InputDate
                    label='تا تاریخ'
                    name='toDate'
                    defaultValue={toDate}
                    handelValue={(_, value) => setToDate(value)}
                  />
                </Col>
                <Col span={6}>
                  <InputNumber
                    label='کد پرسنلی پیوست'
                    name='payvastPersonalCode'
                    handelValue={(_, value) => setPayvastPersonalCode(value)}
                  />
                </Col>
                <Col span={6}>
                  <InputControl
                    name='hasInsuranceType'
                    url='/workerInsuranceReport/hasInsuranceTypeTypeDropdown'
                    label='وضعیت بیمه'
                    handelValue={(_, value) => setHasInsuranceType(value)}
                  />
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={6}>
                  <InputControlAsync
                    url='/worker/search'
                    label='انتخاب نیرو'
                    name='workerId'
                    handelValue={(_, value) => setWorkerId(value)}
                  />
                </Col>
                <Col span={6}>
                  <InputControl
                    url='/common/profilebusinesstypedropdown'
                    label='نوع بیزینس کار نیرو'
                    name='profileBusinessType'
                    handelValue={(_, value) => setProfileBusinessType(value)}
                  />
                </Col>
                {profileBusinessType !== null && (
                  <Col span={6}>
                    {profileBusinessType === 0 ? (
                      <InputControlAsyncMulti
                        url='/userManagement/searchdropdown'
                        label='مشتری ها'
                        name='customerIds'
                        isDefaultValue={false}
                        handelValue={(_, value) => setCustomerIds(value)}
                        disabled={withoutCustomerIds?.length > 0}
                      />
                    ) : (
                      <InputControlAsyncMulti
                        url='/userManagement/B2BSearchDropDown'
                        label='مشتری ها'
                        name='customerIds'
                        isDefaultValue={false}
                        handelValue={(_, value) => setCustomerIds(value)}
                        disabled={withoutCustomerIds?.length > 0}
                      />
                    )}
                  </Col>
                )}
                {profileBusinessType !== null && (
                  <Col span={6}>
                    {profileBusinessType === 0 ? (
                      <InputControlAsyncMulti
                        url='/userManagement/searchdropdown'
                        label='مشتری نیستند'
                        name='withoutCustomerIds'
                        isDefaultValue={false}
                        handelValue={(_, value) => setWithoutCustomerIds(value)}
                        disabled={customerIds.length > 0}
                      />
                    ) : (
                      <InputControlAsyncMulti
                        url='/userManagement/B2BSearchDropDown'
                        label='مشتری نیستند'
                        name='withoutCustomerIds'
                        isDefaultValue={false}
                        handelValue={(_, value) => setWithoutCustomerIds(value)}
                        disabled={customerIds.length > 0}
                      />
                    )}
                  </Col>
                )}
              </Row>
              <Row gutter={20}>
                <Col span={12}>
                  <Button
                    type='primary'
                    style={{ width: '100%' }}
                    loading={loading}
                    onClick={() => search()}
                  >
                    جستجو
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    type='primary'
                    danger
                    ghost
                    style={{ width: '100%' }}
                    onClick={() => reset()}
                  >
                    پاک کردن فرم جستجو
                  </Button>
                </Col>
              </Row>
            </Panel>
          </Collapse>
        </div>
      </div>

      <Row
        gutter={20}
        style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}
      >
        <Col span={3}>
          <Button
            style={{ width: '100%' }}
            loading={excelLoading}
            onClick={() => getExcel()}
          >
            خروجی اکسل
          </Button>
        </Col>
      </Row>

      <Table
        size='small'
        style={{ textAlign: 'right', marginTop: 20 }}
        rowClassName={(row, index) => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
      />
      <div style={{ marginTop: -40 }}>
        تعداد کل {totalRecord}
        <br />
      </div>
    </>
  );
};

export default hocFrom(InsuranceReport);
